import AppDialog from '../app_dialog'
import { TextField, Select, DatePicker, fromUtcDateValue, toUtcDateValue } from '@cinesend/ui-kit'
import { useQueryClient, useQuery } from '@tanstack/react-query'
import { useState } from 'react'
import useStore from '../../hooks/use_store'

const EditModal = ({ onClose, disabled, cycle, invalidateKey }) => {
  const queryClient = useQueryClient()
  const { data: schemas } = useQuery(['/api/schemas'])
  const { updateModel } = useStore()
  const [state, setState] = useState(cycle)

  const update = (data) => {
    setState({ ...state, ...data })
  }

  const saveCycleData = () => {
    updateModel.mutate(
      {
        endpoint: 'cycles',
        id: cycle.id,
        data: state,
      },
      {
        onSuccess: () => queryClient.setQueryData(['cycles/', cycle.id], { ...state }),
        onError: (err) => console.log(err),
        onSettled: () => {
          queryClient.invalidateQueries([invalidateKey])
          onClose()
        },
      }
    )
  }

  const schemasToOptions = schemas?.map((schema) => ({ value: String(schema.id), label: schema.name })) ?? []

  return (
    <AppDialog
      title='Edit cycle'
      onClose={onClose}
      confirmText='Save'
      onConfirm={() => saveCycleData()}
      confirmDisabled={updateModel.isLoading}
    >
      <div className={'max-h-96 space-y-4'}>
        <p className='pb-4'>{cycle.description}</p>
        <TextField
          label={`Name`}
          value={state.name}
          onChange={(e) => update({ name: e.target.value })}
          placeholder={`Enter new name here...`}
          autoFocus
        />
        <DatePicker
          fullWidth
          label={'Start Date'}
          value={toUtcDateValue(state.start_date)}
          onValueChange={(value) => update({ start_date: fromUtcDateValue(value) }, false)}
        />
        <DatePicker
          fullWidth
          label={'End Date'}
          value={toUtcDateValue(state.end_date)}
          onValueChange={(value) => update({ end_date: fromUtcDateValue(value) }, false)}
        />
        <Select
          fullWidth
          label={'Schema'}
          placeholder='Select Schema'
          options={schemasToOptions}
          value={String(state.schema_id)}
          onValueChange={(schemaID) => {
            update({ schema_id: Number(schemaID) })
          }}
          disabled={disabled}
        />
      </div>
    </AppDialog>
  )
}

export default EditModal
